import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; // @ts-check

import React, { useState } from 'react';
import { List, ListItem, ListItemText, ListItemIcon, Typography, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '../../../../Icon';
import RelationshipDialog from './RelationshipDialog';
import ErrorDialog from '../components/ErrorDialog';
import { useDocumentDispatch, useDocumentState } from '../context/documentContext';
var useStyles = makeStyles(function (theme) {
  return {
    disabledText: {
      color: theme.palette.text.hint
    },
    listIcon: {
      marginRight: theme.spacing(1),
      fontSize: '1rem'
    },
    list: {
      margin: theme.spacing(0, -3)
    },
    listItem: {
      height: 34,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(2)
    }
  };
}, {
  name: 'ECRelationships'
});

var Relationships = function Relationships() {
  var classes = useStyles({});
  var documentState = useDocumentState();
  var documentDispatch = useDocumentDispatch();
  /** @param {import('../context/reducers/contentReducer/types').DasJob} job */

  var selectRelationships = function selectRelationships(job) {
    if (job.outputType === 'bi-universe') {
      var universe = job.biUniverseOutput.biUniverse;
      return universe.relationships.items;
    } else {
      var getRelationship = function getRelationship(parent, child) {
        var childDataSource = job.dataSources.find(function (dataSource) {
          return dataSource.id === child.dataSource;
        });
        if (!childDataSource) return null;
        var sourceColumn = null;
        var destinationColumn = null;

        if (childDataSource.elementName === 'equalFilterFunction') {
          sourceColumn = childDataSource.parentField;
          destinationColumn = childDataSource.field;
        }

        return {
          id: child.id,
          sourceTable: parent.id,
          destinationTable: child.id,
          sourceColumn: sourceColumn,
          destinationColumn: destinationColumn
        };
      };

      var getChildrenRelationships = function getChildrenRelationships(parent) {
        var result = [];
        parent.elements.forEach(function (child) {
          if (child.elementName === 'elementSequence' && parent.elementName === 'elementSequence') {
            var relationship = getRelationship(parent, child);
            if (relationship) result.push(relationship);
          }

          result = result.concat(getChildrenRelationships(child));
        });
        return result;
      };

      return getChildrenRelationships(job.output.element);
    }
  };
  /** @param {import('../context/reducers/contentReducer/types').DasJob} job */


  var selectTables = function selectTables(job) {
    if (job.outputType === 'bi-universe') {
      return job.biUniverseOutput.biUniverse.tables;
    } else {
      // Get all element sequences in the output and convert them
      // to a table like format
      var getDescendantElements = function getDescendantElements(elements, result) {
        elements.forEach(function (element) {
          if (element.elementName === 'elementSequence') result.push(element);
          getDescendantElements(element.elements, result);
        });
        return result;
      };

      var elements = getDescendantElements(job.output.element.elements, []);
      return elements.map(function (element) {
        var elementDataSource = job.dataSources.find(function (dataSource) {
          return dataSource.id === element.dataSource;
        });
        if (!elementDataSource) return null;

        if (elementDataSource.elementName === 'equalFilterFunction') {
          elementDataSource = job.dataSources.find(function (dataSource) {
            return dataSource.id === elementDataSource.dataSource;
          });
        }

        return {
          id: element.id,
          name: element.name,
          dimensions: elementDataSource.fields
        };
      }).filter(function (item) {
        return item;
      });
    }
  };

  var relationships = selectRelationships(documentState.content.job);
  var tables = selectTables(documentState.content.job);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dialog = _useState2[0],
      setDialog = _useState2[1];

  return React.createElement("div", null, React.createElement(Typography, {
    variant: "h6"
  }, "Relationships"), React.createElement(Typography, {
    className: classes.disabledText,
    gutterBottom: true
  }, "Click to add a new relationship"), React.createElement(List, {
    className: classes.list
  }, relationships.map(function (relationship) {
    return React.createElement(ListItem, {
      key: relationship.id,
      button: true,
      dense: true,
      className: classes.listItem,
      onClick: function onClick() {
        return setDialog({
          relationship: relationship
        });
      }
    }, React.createElement(ListItemIcon, null, React.createElement(Icon, {
      type: "dependencies",
      className: classes.listIcon
    })), React.createElement(ListItemText, {
      disableTypography: true
    }, React.createElement(RelationshipName, {
      relationship: relationship,
      tables: tables
    })));
  })), React.createElement(Icon, {
    type: "add",
    className: classes.listIcon,
    onClick: function onClick() {
      return setDialog({});
    },
    buttonSize: "small"
  }), dialog && (tables.length <= 1 ? React.createElement(ErrorDialog, {
    header: "Add Relationship",
    message: "There should be at least two tables to define a relationship.",
    onClose: function onClose() {
      return setDialog(null);
    }
  }) : React.createElement(RelationshipDialog, {
    tables: tables,
    onSubmit: function onSubmit(relationshipValues) {
      documentDispatch({
        type: 'update_relationship',
        payload: _objectSpread({
          id: dialog.relationship ? dialog.relationship.id : undefined
        }, relationshipValues)
      });
    },
    onRemove: function onRemove() {
      documentDispatch({
        type: 'remove_relationship',
        payload: dialog.relationship.id
      });
      setDialog(null);
    },
    onClose: function onClose() {
      return setDialog(null);
    },
    values: dialog.relationship ? dialog.relationship : undefined
  })));
};

var RelationshipName = function RelationshipName(_ref) {
  var relationship = _ref.relationship,
      tables = _ref.tables;
  var sourceTable = tables.find(function (currentTable) {
    return currentTable.id === relationship.sourceTable;
  });
  var destinationTable = tables.find(function (currentTable) {
    return currentTable.id === relationship.destinationTable;
  });
  var foreignKey = destinationTable.dimensions.find(function (dimension) {
    return dimension.id === relationship.destinationColumn;
  });
  var title = "".concat(foreignKey ? foreignKey.name : '-', " (").concat(destinationTable ? destinationTable.name : '-', "/").concat(sourceTable ? sourceTable.name : '-', ")");
  return React.createElement(Tooltip, {
    title: title
  }, React.createElement(Typography, {
    noWrap: true
  }, title));
};

export default Relationships;